
import u from "umbrellajs"
import { EventEmitter } from "events"
// related to components/widgets/switch_mode



interface Selector {
  // the overlay part
  overlay:          string
  switches_anchors: string
  // small div
  page:             string
}

export interface InputSelector {
  // the overlay part
  overlay?:          string
  switches_anchors?: string
  // small div
  page?:             string
}

const DEFAULT_SELECTOR = {
  // the overlay part
  overlay:          ".cell--new-development-buildings--pictures-and-map-browser--tabbed__overlay",
  switches_anchors: ".cell--new-development-buildings--pictures-and-map-browser--tabbed__switch",
  // small div
  page:             ".cell--overlay-on-page",
}



const MODE_PREFIX = "with-mode-"
const ACTIVE_CLASS_NAME = "js--switch--active"
const TARGET_DATA_ATTR = "js-app-toggle-target"
const MODE_DATA_ATTR = "js-app-toggle-to"


class ActiveSwitches extends EventEmitter {
  protected selector: Selector

  protected $switches_anchors: UmbrellaInstance
  protected $overlay_switches = null as UmbrellaInstance | null
  protected $page_switches = null as UmbrellaInstance | null

  protected current_mode = null as string | null


  constructor(selector: InputSelector) {
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$switches_anchors = u(this.selector.switches_anchors)
    // The switches can be empty
    // Which could mean the element/component is absent
    // So we skip initialization
    if (this.$switches_anchors.length === 0) { return }

    this.$overlay_switches = u(this.selector.overlay).find(this.selector.switches_anchors)
    this.$page_switches = u(this.selector.page).find(this.selector.switches_anchors)

    this.created()
    this.bind_action()
  }

  public getCurrentMode() {
    return this.current_mode
  }

  protected created(){
    if (this.$overlay_switches == null) { return }
    if (this.$page_switches == null) { return }

    [
      this.$overlay_switches,
      this.$page_switches,
    ].forEach(markFirstActive)
    const targetSelector = (this.$page_switches.first() as HTMLElement)
    .getAttribute(`data-${TARGET_DATA_ATTR}`)?.toString() || ""
    const new_mode = (this.$page_switches.first() as HTMLElement)
    .getAttribute(`data-${MODE_DATA_ATTR}`)?.toString() || ""
    const new_mode_class = `${MODE_PREFIX}${new_mode}`
    const $targets = u(targetSelector)
    $targets.addClass(new_mode_class)

    this.current_mode = new_mode
  }
  protected bind_action(){
    this.$switches_anchors.on("click", (e) => {
      this.onSwitchClick(e)
    })
  }

  private onSwitchClick(e: Event){
    e.preventDefault()

    const event_target = e.currentTarget
    if (event_target == null) { return }

    const $el = u(event_target as HTMLElement)
    if ((event_target as HTMLElement).classList.contains("switch--disabled") ) {
      return
    }
    this.$switches_anchors.removeClass(ACTIVE_CLASS_NAME)
    const modeSelector = $el.data(MODE_DATA_ATTR).toString()
    const $modeSwitches = this.$switches_anchors.filter(`[data-${MODE_DATA_ATTR}='${modeSelector}']`)

    $modeSwitches.addClass(ACTIVE_CLASS_NAME)

    this.current_mode = modeSelector

    this.emit("switch_click")
  }
}

function markFirstActive($el: UmbrellaInstance){
  ($el.first() as HTMLElement)?.classList?.add(ACTIVE_CLASS_NAME)
}


export {
  ActiveSwitches,
}
